export default __webpack_public_path__ + "static/creator_bg-big-55b8cd47bce19607fa9b3bd2592336aa.jpg";